import React from "react";
import "./LoadingPlaceholder.css";

const LoadingPlaceholder: React.FC = () => (
  <div className="loading-placeholder">
    <div className="loading-spinner"></div>
  </div>
);

export default LoadingPlaceholder;
